<template>

  <b-col class="card-gradiant p-0 m-0">

    <div :class="{'s517-image':imageVisibility}">
      <img :src="image" class="s517-image " v-if="imageVisibility" :alt="alt">
    </div>

    <div class="text-area px-3">

      <div class="text-slicer my-3">
        <slot name="p-1"/>
      </div>

      <div class="text-slicer my-3">
        <slot name="p-2"/>
      </div>

      <div class="button-area">
        <slot name="p-3"/>
      </div>

    </div>

  </b-col>

</template>

<script>
export default {
  name: "S517",
  props: {
    image: {
      default: 'https://picsum.photos/1920/1080'
    },
    alt: {
      default: 'Mix it web'
    },
    imageVisibility: {
      default: true
    }
  }
};
</script>

<style scoped>
.card-gradiant {
  height: 250px;
}

.s517-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0px;
  bottom: 0;
  right: 0;
  background: rgb(42, 60, 110);
  background: linear-gradient(90deg, rgba(var(--light-info), 0) 0%, rgba(var(--light-success), 1) 100%);
}

.text-area {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  z-index: 2;
}

.text-slicer {
  font-size: 16px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}


.s517-image {
  object-fit: cover;
  height: 250px;
  width: 100%;
}


.button-area * {
  transition: 0.3s;
}

.button-area *::after {
  content: "";
  position: absolute;
  background-color: var(--secondary);
  bottom: 0;
  right: 15px;
  height: 1px;
  width: 40%;
  z-index: 5;
  transition: 0.3s;
}


.button-area:hover > *::after {
  width: 0px;
  transition: 0.3s;
}

.button-area:hover > * {
  margin-right: 20px;
}

</style>
